import React from "react";
import { Tag } from "lucide-react";

export function ReferralField({ value, onChange, partner, inputCls }) {
  return (
    <div data-testid="referral-code-section" className="rounded-2xl bg-white border border-[#E2EBF0] p-6 shadow-lg shadow-emerald-950/5">
      <div className="flex items-center gap-2 font-display font-bold text-lg text-[#03281B] mb-1"><Tag size={20} className="text-[#008057]" /> Referral Code</div>
      <p className="text-sm text-slate-500 mb-3">Were you referred by a club or partner? Enter their code here (optional).</p>
      <input
        data-testid="input-referral-code"
        className={`${inputCls} uppercase tracking-wider font-mono max-w-xs`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value.toUpperCase().replace(/\s/g, ""))}
        placeholder="e.g. COMETS2027"
        maxLength={30}
      />
      {partner && <p data-testid="referral-code-valid" className="text-sm text-[#008057] font-semibold mt-2">Code applied: referred by {partner}</p>}
    </div>
  );
}
